/**
 * ╔══════════════════════════════════════════════════════════════╗
 * ║              © 2026 Madar.iq — All Rights Reserved          ║
 * ║   This software is proprietary and confidential.            ║
 * ║   Unauthorized use, copying or distribution is prohibited.  ║
 * ╚══════════════════════════════════════════════════════════════╝
 */

// ── جميع الـ imports أولاً (ESLint requirement) ──────────────────
import { validateDomainLicense } from "./protection/license-validator";
import "./i18n";
import "./index.css";
import React from "react";
import { setupGlobalThemeFonts } from "./theme/ThemeConfigProvider";
import ReactDOM from "react-dom/client";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import theme from "./admindashboard/context/ThemeContext";
import { SearchProvider } from "./admindashboard/context/SearchContext";
import { StoreProvider } from "./context/store/StoreProvider";
import { AuthProvider } from "./context/auth/AuthProvider";

const loadDevtoolsGuard =
  process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_ALLOW_DEVTOOLS !== "true";

if (loadDevtoolsGuard) {
  require("./protection/devtools-guard");
}

// ── تشغيل التحقق من الترخيص فور بدء التطبيق ──────────────────
validateDomainLicense();

// Initialize Theme Assets new
setupGlobalThemeFonts();

const getSavedLang = () => {
  try {
    const saved = window.localStorage.getItem("lang");
    if (saved && saved.toLowerCase().startsWith("ar")) return "ar";
    if (saved && saved.toLowerCase().startsWith("en")) return "en";
  } catch {
    /* ignore */
  }
  return "ar";
};

const savedLang = getSavedLang();
document.documentElement.lang = savedLang;
document.documentElement.dir = savedLang === "ar" ? "rtl" : "ltr";
document.documentElement.style.setProperty("--webkit-tap-highlight-color", "transparent");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <StoreProvider>
            <SearchProvider>
              <App />
            </SearchProvider>
          </StoreProvider>
        </AuthProvider>
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);
